var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkmenistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.104 0 10.2313 0.0990469 9.39135 0.285234L8.86963 12L9.39135 23.7147C10.2313 23.9009 11.1041 24 12 24C18.6274 24 24 18.6274 24 12C23.9999 5.37258 18.6274 0 12 0V0Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13047 3.91739C1.1859 6.05001 6.10352e-05 8.88642 6.10352e-05 12C6.10352e-05 15.1135 1.18595 17.9499 3.13051 20.0826L3.65223 12L3.13047 3.91739Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.551 9.05151C18.1414 7.40592 17.4781 5.61618 16.0547 4.72481C16.3107 4.75814 16.567 4.81842 16.8199 4.90912C18.7185 5.59031 19.7054 7.6815 19.0242 9.58003C18.343 11.4787 16.2519 12.4655 14.3533 11.7843C14.1003 11.6936 13.8641 11.5771 13.6453 11.4401C15.3108 11.657 16.9606 10.6971 17.551 9.05151Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2764 4.27373L13.7634 4.93663L12.9745 4.65356L13.4464 5.34627L12.9334 6.00909L13.738 5.77443L14.21 6.46706L14.2353 5.62931L15.0399 5.3946L14.2511 5.11162L14.2764 4.27373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6617 6.43369L15.1486 7.09654L14.3597 6.81347L14.8316 7.50619L14.3186 8.169L15.1232 7.93425L15.5952 8.62701L15.6206 7.78922L16.4252 7.55447L15.6363 7.27144L15.6617 6.43369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.834 5.06038L11.321 5.72319L10.5321 5.44021L11.004 6.13288L10.491 6.79574L11.2956 6.56103L11.7675 7.25371L11.7929 6.41596L12.5975 6.18125L11.8087 5.89818L11.834 5.06038Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7778 7.53455L11.2648 8.19741L10.4759 7.91437L10.9478 8.60709L10.4348 9.26991L11.2395 9.03525L11.7113 9.72787L11.7367 8.89012L12.5414 8.65542L11.7524 8.37234L11.7778 7.53455Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1322 8.37927L13.6191 9.04208L12.8303 8.75905L13.3022 9.45177L12.7891 10.1145L13.5938 9.87988L14.0657 10.5726L14.0911 9.73476L14.8957 9.5001L14.1068 9.21707L14.1322 8.37927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13043 3.91739V20.0826C4.76543 21.8757 6.93715 23.1706 9.39129 23.7147V0.285233C6.9371 0.829264 4.76548 2.12419 3.13043 3.91739Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51967 6.31805L4.4715 5.53721V4.43297L5.51967 3.65218H7.00209L8.05026 4.43297V5.53721L7.00209 6.31805H5.51967Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2609 3.65218H5.51967L4.4715 4.43297V4.97283H6.2609V3.65218Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26093 6.31805H7.00211L8.05028 5.5372V4.97391H6.26093V6.31805Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51967 20.3477L4.4715 19.5669V18.4627L5.51967 17.6819H7.00209L8.05026 18.4627V19.5669L7.00209 20.3477H5.51967Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2609 17.6819H5.51967L4.4715 18.4627V19.0026H6.2609V17.6819Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26093 20.3477H7.00211L8.05028 19.5669V19.0036H6.26093V20.3477Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51967 13.3329L4.4715 12.5521V11.4479L5.51967 10.667H7.00209L8.05026 11.4479V12.5521L7.00209 13.3329H5.51967Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08694 15.0509H7.63038V14.5944H6.82811L6.26083 14.0271L5.6936 14.5944H4.89133V15.0509H4.43481V15.9639H4.89133V16.4204H5.69355L6.26088 16.9877L6.82811 16.4204H7.63038V15.9639H8.08694V15.0509Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08694 8.03597H7.63038V7.57941H6.82811L6.26083 7.01213L5.6936 7.57941H4.89133V8.03597H4.43481V8.94901H4.89133V9.40552H5.69355L6.26088 9.9729L6.82811 9.40552H7.63038V8.94901H8.08694V8.03597Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73907 11.4782H6.78256V12.5217H5.73907V11.4782Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26079 9.01402C6.54893 9.01402 6.78251 8.78044 6.78251 8.4923C6.78251 8.20416 6.54893 7.97058 6.26079 7.97058C5.97266 7.97058 5.73907 8.20416 5.73907 8.4923C5.73907 8.78044 5.97266 9.01402 6.26079 9.01402Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26079 16.0293C6.54893 16.0293 6.78251 15.7957 6.78251 15.5076C6.78251 15.2194 6.54893 14.9858 6.26079 14.9858C5.97266 14.9858 5.73907 15.2194 5.73907 15.5076C5.73907 15.7957 5.97266 16.0293 6.26079 16.0293Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkmenistan);
export default __webpack_public_path__ + "static/media/turkmenistan.b1340f5fe13cbbc1be01f379053889a4.svg";
export { ForwardRef as ReactComponent };